import { DashboardService } from 'data/services/dashboard/dashboard.service';
import { makeListLastRegistration } from 'main/factories/usecases/dashboard/list-last-registration-app';
import { makeOnlineUsersPlatform } from 'main/factories/usecases/dashboard/list-users-online-platform';
import { makeGetMapActivitiesMarkers } from 'main/factories/usecases/dashboard/maps/remote-get-map-activities-markers-factory';
import { makeGetMapActivityDetails } from 'main/factories/usecases/dashboard/maps/remote-get-map-activity-details-factory';
import { makeGetMapInternshipMarkers } from 'main/factories/usecases/dashboard/maps/remote-get-map-internship-markers-factory';
import { makeListOnlineUsersPerOrganizationIndicators } from 'main/factories/usecases/dashboard/online-users-per-organization';
import { makeGetActivityByStatus } from 'main/factories/usecases/dashboard/remote-get-activity-by-status';
import { makeGetAllActivitiesByGroup } from 'main/factories/usecases/dashboard/remote-get-all-activities-by-group-factory';
import { makeGetAllActivitiesByPlace } from 'main/factories/usecases/dashboard/remote-get-all-activities-by-place-factory';
import { makeGetAllActivitiesByStatus } from 'main/factories/usecases/dashboard/remote-get-all-activities-by-status-factory';
import { makeGetAllActivitiesByStudent } from 'main/factories/usecases/dashboard/remote-get-all-activities-by-student-factory';
import { makeGetAllActivitiesByTask } from 'main/factories/usecases/dashboard/remote-get-all-activities-by-task-factory';
import { makeGetActivitiesInProgressCount } from 'main/factories/usecases/dashboard/remote-get-activities-in-progress-count-factory';
import { makeGetCompletedAndMissedActivitiesCount } from 'main/factories/usecases/dashboard/remote-get-completed-and-missed-activities-count-factory';
import { makeGetAllCHMetrics } from 'main/factories/usecases/dashboard/remote-get-all-ch-metrics-factory';
import { makeGetAllUsersMetrics } from 'main/factories/usecases/dashboard/remote-get-all-users-metrics-factory';
import { makeGetSummaryProfile } from 'main/factories/usecases/dashboard/remote-get-summary-profile-factory';

export const makeDashboardService = () => {
  return new DashboardService(
    makeGetAllActivitiesByGroup(),
    makeGetAllActivitiesByPlace(),
    makeGetAllActivitiesByTask(),
    makeGetAllActivitiesByStatus(),
    makeGetAllActivitiesByStudent(),
    makeGetAllCHMetrics(),
    makeGetAllUsersMetrics(),
    makeGetCompletedAndMissedActivitiesCount(),
    makeGetActivitiesInProgressCount(),
    makeGetSummaryProfile(),
    makeGetActivityByStatus(),
    makeListOnlineUsersPerOrganizationIndicators(),
    makeListLastRegistration(),
    makeOnlineUsersPlatform(),
    makeGetMapActivitiesMarkers(),
    makeGetMapInternshipMarkers(),
    makeGetMapActivityDetails(),
  );
};
